Questa prova contiene _4 domande_ da risolvere in _3 ore_.
Tutte le domande sono di **programmazione** tramite blocchi, e sono ordinate per difficoltà crescente.
**Attento che la difficoltà è soggettiva!** Se stai passando tanto tempo cercando di risolvere una domanda, prova a passare ad altre domande e altre categorie!

## Punteggio

Tutte le domande sono a _blocchi_ e richiedono di scrivere un singolo programma a blocchi, che viene valutato su 10 diversi livelli.
Per ciascuna domanda e per ciascun livello, Il punteggio che puoi ottenere è:

- 5 punti se il programma produce la risposta _corretta_;
- 0 punti se il programma produce una risposta _sbagliata_.

Quindi ogni domanda a blocchi può valere fino a 50 punti in totale.

In ogni domanda a blocchi, i primi 5 livelli vengono anche visualizzati graficamente, mentre gli ultimi 5 livelli non vengono visualizzati.
